import AlterarSenha from '@/modules/login/alterar-senha/AlterarSenha.vue';
import HeaderExterno from '@/modules/criar-conta/HeaderExterno.vue';

export default {
  path: '/redefinir-senha/:chave',
  name: 'redefinir-snha',
  components: {
    header: HeaderExterno,
    default: AlterarSenha,
  },
};
